export type MarkdownHeading = {
  depth: 2 | 3;
  label: string;
  id: string;
};

export const headingAnchor = (label: string) =>
  label
    .toLocaleLowerCase()
    .replace(/[`*_~]/g, "")
    .replace(/\[([^\]]+)]\([^)]+\)/g, "$1")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const extractMarkdownHeadings = (
  markdown: string,
): MarkdownHeading[] => {
  const headings: MarkdownHeading[] = [];
  const seen = new Map<string, number>();
  let fence: { marker: "`" | "~"; length: number } | null = null;
  for (const line of markdown.split("\n")) {
    if (fence) {
      const escapedMarker = fence.marker === "`" ? "`" : "~";
      const closingFence = new RegExp(
        `^\\s{0,3}${escapedMarker}{${fence.length},}\\s*$`,
      );
      if (closingFence.test(line)) fence = null;
      continue;
    }

    const openingFence = /^\s{0,3}(`{3,}|~{3,})/.exec(line);
    if (openingFence) {
      fence = {
        marker: openingFence[1][0] as "`" | "~",
        length: openingFence[1].length,
      };
      continue;
    }

    const match = /^(##|###)\s+(.+?)\s*#*\s*$/.exec(line);
    if (!match) continue;
    const label = match[2].replace(/[`*_~]/g, "").trim();
    const baseId = headingAnchor(label) || "section";
    const count = seen.get(baseId) ?? 0;
    seen.set(baseId, count + 1);
    headings.push({
      depth: match[1].length as 2 | 3,
      label,
      id: count ? `${baseId}-${count + 1}` : baseId,
    });
  }
  return headings;
};
